import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export default function SectionHeader({ title, seeAllHref, testId }) {
  const { t } = useI18n(); // Iter 704 — section titles follow the site language
  return (
    <div className="flex items-center justify-between mb-4 md:mb-6" data-testid={testId}>
      <h2 className="font-display text-xl md:text-2xl lg:text-3xl font-extrabold text-slate-900 tracking-tight">
        {t(title)}
      </h2>
      {seeAllHref && (
        <Link
          to={seeAllHref}
          className="inline-flex items-center gap-1.5 rounded-full border border-[color:var(--brand-blue)] text-[color:var(--brand-blue)] hover:bg-[color:var(--brand-blue)] hover:text-white transition-colors px-4 py-1.5 text-xs md:text-sm font-semibold"
        >
          {t("See All")} <ArrowRight className="w-3.5 h-3.5" />
        </Link>
      )}
    </div>
  );
}
